import Vue from 'vue'
import Router from 'vue-router'

import GestaoCadastros from '../pages/GestaoCadastros/Index.vue'
import BuscaAtivaCadastro from '../pages/GestaoCadastros/BuscaAtivaCadastro/Index.vue'
import CidadaosDuplicados from '../pages/GestaoCadastros/CidadaosDuplicados/Index.vue'
import CidadaosSemAcs from '../pages/GestaoCadastros/CidadaosSemAcs'
import CadastrosSemCpf from '../pages/GestaoCadastros/CadastrosSemCpf/Index.vue'
import CidadaosCnsInvalidos from '../pages/GestaoCadastros/CidadaosCnsInvalidos/Index'
import CidadaosDesatualizados from '../pages/GestaoCadastros/CidadaosDesatualizados/Index'

import CalculadoraDePessoas from '../pages/GestaoCadastros/CalculadoraDePessoas/Index'
import Obitos from '@/pages/GestaoCadastros/Obitos/Index'
import ObitosPorEquipeAcs from '@/pages/GestaoCadastros/Obitos/PorEquipeAcs'
import ObitosPorProfissional from '@/pages/GestaoCadastros/Obitos/PorProfissional'
import MudancaTerritorio from '@/pages/GestaoCadastros/MudancaTerritorio/Index'
import MudancaTerritorioPorEquipeAcs from '@/pages/GestaoCadastros/MudancaTerritorio/PorEquipeAcs'
import MudancaTerritorioProfissional from '@/pages/GestaoCadastros/MudancaTerritorio/PorProfissional'

function authMiddlewareCidadaoPainel(to, from, next) {
  // só aplica se a rota exigir autenticação
  if (!to.matched.some((r) => r.meta.requiresAuth)) {
    return next()
  }

  // tenta recuperar o objeto salvo no sessionStorage
  const vuex = JSON.parse(sessionStorage.getItem('vuex') || '{}')
  const token = vuex?.accessToken || null
  if (!token) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  const parceiro = vuex?.infoMunicipio?.parceiro
  if (parceiro == null) {
    return next()
  }

  if (parceiro != null && vuex?.id_funcao == '2') {
    return next()
  } else {
    return next({
      path: '/pagina-indisponivel',
    })
  }
}

export default [
  {
    path: '/gestao-cadastros',
    component: GestaoCadastros,
  },
  {
    path: '/gestao-cadastros/cidadao/painel',
    name: 'cidadao-painel',
    component: () => import('@/pages/GestaoCadastros/CidadaoPainel/Index.vue'),
    // meta: { requiresAuth: true },
    // beforeEnter: authMiddlewareCidadaoPainel,
  },
  {
    path: '/gestao-cadastros/busca-ativa-cadastro',
    component: BuscaAtivaCadastro,
  },
  {
    path: '/gestao-cadastros/cidadaos-duplicados',
    component: () =>
      import('@/pages/GestaoCadastros/CidadaosDuplicados/Template.vue'),
    children: [
      {
        path: '/gestao-cadastros/cidadaos-duplicados',
        component: CidadaosDuplicados,
      },
    ],
  },
  {
    path: '/gestao-cadastros/cidadaos-sem-acs',
    component: CidadaosSemAcs,
  },
  {
    path: '/gestao-cadastros/cadastros-sem-cpf',
    component: () =>
      import('@/pages/GestaoCadastros/CadastrosSemCpf/Template.vue'),
    children: [
      {
        path: '/gestao-cadastros/cadastros-sem-cpf',
        component: CadastrosSemCpf,
      },
    ],
  },
  {
    path: '/gestao-cadastros/cidadaos-cns-invalidos',
    component: CidadaosCnsInvalidos,
  },
  {
    path: '/gestao-cadastros/cidadaos-desatualizados',
    component: CidadaosDesatualizados,
  },
  {
    path: '/gestao-cadastros/calculadora-de-pessoas',
    component: () =>
      import('@/pages/GestaoCadastros/CalculadoraDePessoas/Template.vue'),
    children: [
      {
        path: '/gestao-cadastros/calculadora-de-pessoas',
        component: CalculadoraDePessoas,
      },
    ],
  },
  {
    path: '/gestao-cadastros/obitos',
    component: () => import('@/pages/GestaoCadastros/Obitos/Template.vue'),
    children: [
      {
        path: '/gestao-cadastros/obitos',
        component: Obitos,
      },
      {
        path: '/gestao-cadastros/obitos/profissional',
        component: ObitosPorProfissional,
      },
      {
        path: '/gestao-cadastros/obitos/equipe/acs',
        component: ObitosPorEquipeAcs,
      },
    ],
  },
  {
    path: '/gestao-cadastros/mudanca_territorio',
    component: () =>
      import('@/pages/GestaoCadastros/MudancaTerritorio/Template.vue'),
    children: [
      {
        path: '/gestao-cadastros/mudanca_territorio/',
        component: MudancaTerritorio,
      },
      {
        path: '/gestao-cadastros/mudanca_territorio/profissional',
        component: MudancaTerritorioProfissional,
      },
      {
        path: '/gestao-cadastros/mudanca_territorio/equipe/acs',
        component: MudancaTerritorioPorEquipeAcs,
      },
    ],
  },
]
